// jshint module: true

import Component from './../../assets/scripts/component/component';
import findParentByClassName from './../../assets/scripts/modules/find-parent-by-classname';

const component = 'background-video';
const selector = `.${component}`;

class BackgroundVideo extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    this.video = this.element.querySelector('video');

    if (!this.video) {
      return;
    }

    window.addEventListener('page-change', (event) => this.togglePause(event), false);

  }

  togglePause(event) {
    const parent = findParentByClassName(this.element, 'page');

    if (!parent) {
      return;
    }

    if (event.detail === parent) {
      this.video.play();
      document.documentElement.classList.add('has-background-video-active');
    } else {
      this.video.pause();
      document.documentElement.classList.remove('has-background-video-active');
    }

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new BackgroundVideo(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/background-video/background-video.js